import type { CheckStatus, HealthCopy, HealthError, Layer } from '@/frontend/features/Fde/dataHealth/types'
import { formatMetric } from '@/frontend/features/Fde/dataHealth/types'

export function layerLabel(layer: Layer | string, copy: HealthCopy) {
  return copy[`layer_${layer}`] ?? layer
}

// Plain title of a metric (the group title in "Precisa de atenção").
export function metricLabel(metric: string, copy: HealthCopy) {
  return copy[`metric_${metric}`] ?? metric
}

// What the metric measures, in one plain sentence.
export function metricHelp(metric: string, copy: HealthCopy) {
  return copy[`metric_help_${metric}`] ?? ''
}

export function subjectLabel(subject: string, copy: HealthCopy) {
  const known = copy[`subject_${subject}`]
  if (known) return known
  const text = subject.replace(/_/g, ' ').trim()
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : subject
}

export function statusLabel(status: CheckStatus, copy: HealthCopy) {
  return copy[`status_${status}`] ?? status
}

export function errorLabel(error: HealthError | undefined, copy: HealthCopy) {
  if (error === 'not_readable') return copy.not_readable
  if (error === 'query_failed') return copy.query_failed
  return null
}

// Unit of a metric's value, when it is a count of something.
const UNITS: Record<string, string> = {
  days_since_last: 'unit_days', partition_days_since_last: 'unit_days', max_gap_days: 'unit_days',
  volume_anomaly_days: 'unit_days', duplicate_keys: 'unit_rows', date_out_of_range: 'unit_rows',
  row_count: 'unit_rows', column_always_empty: 'unit_filled_rows',
}

export function valueText(metric: string, value: number | null | undefined, copy: HealthCopy) {
  const unit = UNITS[metric] ? copy[UNITS[metric]] : ''
  const text = formatMetric(metric, value)
  return unit && value != null ? `${text} ${unit}` : text
}

export const statusClass: Record<CheckStatus, string> = {
  ok: 'border-emerald-600/30 bg-emerald-50 text-emerald-700 dark:border-emerald-400/30 dark:bg-emerald-950/50 dark:text-emerald-300',
  warn: 'border-amber-500/40 bg-amber-50 text-amber-700 dark:border-amber-400/40 dark:bg-amber-950/50 dark:text-amber-300',
  fail: 'border-red-600/30 bg-red-50 text-red-700 dark:border-red-400/30 dark:bg-red-950/50 dark:text-red-300',
}

export const dotClass: Record<CheckStatus, string> = {
  ok: 'bg-emerald-500',
  warn: 'bg-amber-500',
  fail: 'bg-red-600',
}
